import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';
import { ClienteDialogComponent } from '../cliente/cliente-dialog/cliente-dialog.component';
import { AddFacturaComponent } from '../facturacion/add-factura/add-factura.component';
import { InfoComponent } from '../objects/info/info/info.component';
import { LoadingComponent } from '../objects/loading/loading.component';
import { AlertComponent } from '../objects/alert/alert/alert.component';
import { AddLiquidacionComponent } from './add-liquidacion/add-liquidacion.component';
import { Liquidacion } from 'src/app/Models/liquidacion/liquidacion';
import { PrintliquidacionComponent } from '../print/printliquidacion/printliquidacion.component';

@Component({
  selector: 'app-liquidacion',
  templateUrl: './liquidacion.component.html',
  styleUrls: ['./liquidacion.component.css']
})
export class LiquidacionComponent implements OnInit {
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild('txtdireccion', null) txtdireccion: ElementRef;
  @ViewChild(AddLiquidacionComponent, null) newliquidacion: AddLiquidacionComponent;
  @ViewChild(PrintliquidacionComponent, null) printliquidacion: PrintliquidacionComponent;

  public usuario: Usuario = new Usuario();
  public facturas: any[] = [];
  public pagarticulo: any = 0;
  public tipo_filtro: number = 0;
  public filtro: Filtro = new Filtro();
  public cliente: Cliente = new Cliente();
  public fechaHoraActual = new Date();
  public locliquida: Liquidacion = new Liquidacion()
  public search = { top: 10, clase: 0, subclase: 0, subgrupo: 0, nombre: '', codigo: '', opcion: 'nombre', scale: 'DESC', fechaprogd: this.data.DateNowCurrent(), fechaprogh: this.data.DateNowCurrent() }
  public alertType: AlertType = new AlertType();

  constructor(private title: Title, private data: DataService, private notify: NotifyService, private auth: AuthService, private route: Router) {
    const firstDayOfMonth = new Date(this.fechaHoraActual.getFullYear(), this.fechaHoraActual.getMonth(), 1);
    this.filtro.fecini = moment(firstDayOfMonth).format('YYYY-MM-DD');
    this.filtro.fecfin = moment(this.fechaHoraActual).format('YYYY-MM-DD');
  }

  ngOnInit() {
    this.title.setTitle('Liquidaciones | Sistema de ventas');
    this.mostrarFiltro()
  }

  getFacturas() {
    this.data.GetSimple(this.data.api.factura).subscribe(r => {
      console.log(r);

      this.facturas = r;
    })
  }
  reiniciarFiltro() {
    this.filtro = {
      ...this.reiniciarObjetoFiltro(this.filtro), // Copia los campos tipofecha, fecini, fecfin
    };
  }

  // Función para reiniciar el objeto filtro manteniendo tipofecha, fecini, fecfin
  private reiniciarObjetoFiltro(obj: Filtro): Partial<Filtro> {
    const { tipofecha, fecini, fecfin } = obj;
    return { tipofecha, fecini, fecfin };
  }

  printLiquidacion(idliquida) {
    //this.route.navigateByUrl('/printer/liquidacion/' + idliquida);
    console.log(idliquida);
    this.printliquidacion.liquidacionID = idliquida;
    this.printliquidacion.filtro.fecha =  moment(new Date()).format('YYYY-MM-DD')
    this.printliquidacion.getLiquidacion()
    setTimeout(() => {
      this.printliquidacion.printer()
    }, 2000);
  }


  mostrarFiltro() {
    console.log(this.filtro);
    this.data.Post('filtrardoc/Liquidacion', this.filtro).subscribe(r => {
      console.log(r);
      if (r.status === 'error') {
        this.facturas = [];
        //this.data.notify(r.message, "Error", this.alertType.error);

      } else {
        this.facturas = r.data;
      }


    }), (e => {
      //this.data.notify(e.message, "Error", this.alertType.error);
      })

  }

  getCliente() {
    this.newliquidacion.serie_boleta = this.data.getSerieBoleta();
    this.newliquidacion.serie_factura = this.data.getSerieFactura();
    this.newliquidacion.show(() => {
      console.log("cerrado");

    })
  }

  showfrmliquidacion() {
    this.newliquidacion.isedit = false
    this.newliquidacion.liquidacion = new Liquidacion()
    this.newliquidacion.liquidacion.fecha = moment().format('YYYY-MM-DD');
    this.newliquidacion.liquidacion.hora = moment().format('HH:mm');
    this.newliquidacion.detcargas = []
    this.newliquidacion.ventasliquidacion = []
    this.newliquidacion.serie_boleta = this.data.getSerieBoleta();
    this.newliquidacion.serie_factura = this.data.getSerieFactura();
    this.newliquidacion.show(() => {
      this.mostrarFiltro();
      console.log("cerrado");
    })
  }

  showeditliquidacion1(i: Liquidacion) {
    console.log("Liquidacion Datos Completos:", i)
    this.newliquidacion.isedit = true
    //this.newliquidacion.liquidacion = new Liquidacion()
    this.newliquidacion.liquidacion = i
    this.newliquidacion.liquidacion.idpersonal = i.idpersonal.idpersonal
    this.newliquidacion.serie_boleta = this.data.getSerieBoleta();
    this.newliquidacion.serie_factura = this.data.getSerieFactura();
    this.newliquidacion.show(() => {
      this.mostrarFiltro();
      console.log("cerrado");
    })
  }

  showeditliquidacion(i: Liquidacion) {
    console.log("Liquidacion:", i);
    this.newliquidacion.isedit = true;
    this.newliquidacion.liquidacion = new Liquidacion();

    // Copiar todas las propiedades
    Object.assign(this.newliquidacion.liquidacion, i);

    // Mantener el objeto completo de idpersonal para el ng-select
    // No reemplazar con solo el ID
    this.newliquidacion.liquidacion.idpersonal = i.idpersonal.idpersonal; // Mantener el objeto

    this.newliquidacion.serie_boleta = this.data.getSerieBoleta();
    this.newliquidacion.serie_factura = this.data.getSerieFactura();

    // Inicializar arrays vacíos
    this.newliquidacion.detcargas = [];
    this.newliquidacion.ventasliquidacion = [];
    this.newliquidacion.gastos = [];
    this.newliquidacion.ingresos = [];

    this.newliquidacion.show(() => {
      this.mostrarFiltro();
      console.log("cerrado");
    });
  }

}
